import styled from '@emotion/styled';
import { shouldForwardProp } from '@/utils/style.utils';
import { color, COLOR_VARIANTS } from '@tajawal/ct-web-design-system';

const TabsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`;

const TabBarItem = styled('div', { shouldForwardProp })<{ $isSelected: boolean; $expandItem: boolean }>`
  flex: 0 0 ${({ $expandItem }) => ($expandItem ? '33.3333%' : '1')};
  border-radius: 40px;
  border: 1px solid
    ${({ $isSelected }) => ($isSelected ? color(COLOR_VARIANTS.AQUA100) : color(COLOR_VARIANTS.GAINSBORO))};
  background: ${({ $isSelected }) => ($isSelected ? color(COLOR_VARIANTS.AQUA10) : color(COLOR_VARIANTS.WHITE))};
  padding: 0px 16px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export default {
  TabsWrapper,
  TabBarItem,
};
